import { DayCareApi } from '../../api/BaseAPI';
import { AllInstitutionsStatisticsResponse, PeriodType } from '../../constants/Statistics';

export class StatisticsApiClient {
  private client: DayCareApi;

  constructor(client: DayCareApi) {
    this.client = client;
  }

  static async ClientFactory(): Promise<StatisticsApiClient> {
    const client = await DayCareApi.ClientFactory();
    return new StatisticsApiClient(client);
  }

  /**
   * 全施設の統計を取得（管理者専用）
   * @param periodType 期間タイプ (weekly | monthly)
   * @param date 日付 (weekly: YYYY-MM-DD, monthly: YYYY-MM)
   */
  async getAllInstitutionsStatistics(periodType: PeriodType, date: string): Promise<AllInstitutionsStatisticsResponse> {
    const response = await this.client.api.get(`/statistics/institutions/${periodType}/${date}`);
    return response.data;
  }
}
